module.exports = __webpack_public_path__ + "img/994.0448aa4b.gif";